function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import withCssProps from '../../hocs/withCssProps';
import styled, { css } from 'styled-components';
import { Text } from '../../atoms/Text';
import { IfacebookCircle, IinstagramCircle, ItwitterCircle, IyoutubeCircle2 } from '../../atoms/AgroIcon/icons';
import { AgroIconButton } from '../../atoms/AgroIconButton';
import { AgroSelectDark } from '../../atoms/AgroSelectDark';
import { AgroToggleDarkMode } from '../../atoms/AgroToggleDarkMode';
import { AgroImg } from '../../atoms/AgroImg/AgroImg';
import { AgroLink } from '../../atoms/AgroLink';
var MobileFooter = withCssProps(function (_ref) {
  var footerData = _ref.footerData,
    tagManager = _ref.tagManager,
    isDarkMode = _ref.isDarkMode,
    toggleMode = _ref.toggleMode;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    footerData && setValue(footerData.country["default"].label);
  }, [footerData]);
  var capitalize = function capitalize(word) {
    return word[0].toUpperCase() + word.slice(1);
  };
  var gtmFooterClick = function gtmFooterClick(data) {
    var gtmEvent = {
      dataLayer: {
        event: 'trackEvent',
        eventCategory: 'Navigation',
        eventAction: 'Footer',
        eventLabel: data
      }
    };
    if (tagManager) {
      tagManager(gtmEvent);
    }
  };
  var getIcon = function getIcon(iname, color) {
    switch (iname) {
      case 'facebook':
        return /*#__PURE__*/React.createElement(IfacebookCircle, {
          fill: color,
          width: "32px",
          height: "32px"
        });
      case 'instagram':
        return /*#__PURE__*/React.createElement(IinstagramCircle, {
          height: "32px",
          width: "32px"
        });
      case 'youtube':
        return /*#__PURE__*/React.createElement(IyoutubeCircle2, {
          fill: color,
          width: "32px",
          height: "32px"
        });
      case 'twitter':
        return /*#__PURE__*/React.createElement(ItwitterCircle, {
          fill: color,
          width: "32px",
          height: "32px"
        });
      default:
        break;
    }
  };
  var buildLinks = function buildLinks(data, text) {
    var links = [];
    links.push(/*#__PURE__*/React.createElement(ListTitle, {
      type: "number-lg",
      key: "title-".concat(data.label),
      styled: footerData.styledComponent
    }, data.label));
    data.items.map(function (item, idx) {
      links.push(/*#__PURE__*/React.createElement(LinkText, {
        target: "_blank",
        rel: "noreferrer",
        title: item.title,
        href: item.href,
        key: "".concat(idx, "-").concat(item.label),
        onClick: function onClick() {
          return gtmFooterClick(text === 'About' ? text : "Business Unit-".concat(item.label));
        },
        variant: "darkMode",
        size: "lg",
        styled: footerData.styledComponent
      }, item.label));
    });
    return links;
  };
  var changeSelect = function changeSelect(label, link) {
    setValue(label);
    gtmFooterClick(label);
    window.location.href = link;
  };
  return /*#__PURE__*/React.createElement(ContainerFooter, null, footerData.downloadApps.show && /*#__PURE__*/React.createElement(AppContainer, null, /*#__PURE__*/React.createElement(ListTitle, {
    type: "heading-xs",
    key: footerData.downloadApps.label,
    styled: footerData.styledComponent
  }, footerData.downloadApps.label), /*#__PURE__*/React.createElement(BadgeContainer, null, /*#__PURE__*/React.createElement(BadgeContainerLink, {
    href: footerData.downloadApps.hrefAppStore,
    rel: "noreferrer",
    target: "_blank",
    onClick: function onClick() {
      return gtmFooterClick('Apps-App store');
    }
  }, /*#__PURE__*/React.createElement(ImgAppStore, {
    imgname: "".concat(footerData.downloadApps.appStoreBadge),
    width: "119",
    height: "35"
  })), /*#__PURE__*/React.createElement(BadgeContainerLink, {
    href: footerData.downloadApps.hrefGooglePlay,
    rel: "noreferrer",
    target: "_blank",
    onClick: function onClick() {
      return gtmFooterClick('Apps-Google play');
    }
  }, /*#__PURE__*/React.createElement(AgroImg, {
    imgname: "".concat(footerData.downloadApps.googlePlayBadge),
    width: "119",
    height: "35"
  })))), footerData.social.show && /*#__PURE__*/React.createElement(ContainerSocial, null, footerData.social.items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SocialIcon, {
      key: index,
      href: item.href,
      rel: "noreferrer",
      target: "_blank",
      title: item.title,
      onClick: function onClick() {
        return gtmFooterClick("Follow us on-".concat(capitalize(item.label)));
      }
    }, /*#__PURE__*/React.createElement(AgroIconButton, {
      variant: "default"
    }, getIcon(item.label, 'white')));
  })), footerData.darkMode.show && /*#__PURE__*/React.createElement(DarkModeContainer, null, /*#__PURE__*/React.createElement(TitleDarkMode, {
    type: "heading-xs",
    styled: footerData.styledComponent
  }, isDarkMode ? footerData.darkMode.labelChecked : footerData.darkMode.label), /*#__PURE__*/React.createElement(AgroToggleDarkMode, {
    onChange: toggleMode,
    checked: isDarkMode
  })), footerData.about.show && /*#__PURE__*/React.createElement(AboutContainer, null, buildLinks(footerData.about, 'About')), /*#__PURE__*/React.createElement(SitesContainer, null, buildLinks(footerData.sites, 'Sites')), /*#__PURE__*/React.createElement(SelectContainer, null, /*#__PURE__*/React.createElement(AgroSelectDark, {
    mb: "xs",
    options: footerData.country.options,
    label: footerData.country.label,
    value: value,
    onOptionSelected: function onOptionSelected(data) {
      changeSelect(data.label, data.href);
    }
  })));
});
export { MobileFooter };
var ContainerFooter = styled.div.withConfig({
  displayName: "MobileFooter__ContainerFooter",
  componentId: "lv466c-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;padding:32px 16px;"]);
var ListTitle = styled(Text).withConfig({
  displayName: "MobileFooter__ListTitle",
  componentId: "lv466c-1"
})(["margin-bottom:2px;text-align:center;", ""], function (_ref2) {
  var styled = _ref2.styled;
  return styled && css(["color:", ";font-family:", ";line-height:", ";letter-spacing:", ";"], styled.colorTitle, styled.fontTitle, styled.lineHeightTitle, styled.letter);
});
var TextStyled = styled(Text).withConfig({
  displayName: "MobileFooter__TextStyled",
  componentId: "lv466c-2"
})(["", ""], function (_ref3) {
  var styled = _ref3.styled;
  return styled && css(["font-family:", ";font-weight:", ";letter-spacing:", ";"], styled.fontItems, styled.weightItems, styled.letter);
});
var LinkText = styled(AgroLink).withConfig({
  displayName: "MobileFooter__LinkText",
  componentId: "lv466c-3"
})(["text-decoration:none;margin-top:16px;", ""], function (_ref4) {
  var styled = _ref4.styled;
  return styled && css(["font-family:", ";font-weight:", ";letter-spacing:", ";"], styled.fontItems, styled.weightItems, styled.letter);
});
var ContainerSocial = styled.div.withConfig({
  displayName: "MobileFooter__ContainerSocial",
  componentId: "lv466c-4"
})(["display:flex;flex-direction:row;margin-bottom:36px;"]);
var SocialIcon = styled.a.withConfig({
  displayName: "MobileFooter__SocialIcon",
  componentId: "lv466c-5"
})(["margin-right:16px;&:last-child{margin-right:0px;}"]);
var AboutContainer = styled.div.withConfig({
  displayName: "MobileFooter__AboutContainer",
  componentId: "lv466c-6"
})(["display:flex;justify-content:center;align-items:center;flex-direction:column;margin-bottom:38px;"]);
var SitesContainer = styled.div.withConfig({
  displayName: "MobileFooter__SitesContainer",
  componentId: "lv466c-7"
})(["display:flex;justify-content:center;align-items:center;flex-direction:column;margin-bottom:46px;"]);
var SelectContainer = styled.div.withConfig({
  displayName: "MobileFooter__SelectContainer",
  componentId: "lv466c-8"
})(["width:100%;"]);
var AppContainer = styled.div.withConfig({
  displayName: "MobileFooter__AppContainer",
  componentId: "lv466c-9"
})(["display:flex;flex-direction:column;justify-content:center;margin-bottom:36px;"]);
var BadgeContainer = styled.div.withConfig({
  displayName: "MobileFooter__BadgeContainer",
  componentId: "lv466c-10"
})(["flex-direction:row;margin-top:10px;"]);
var ImgAppStore = styled(AgroImg).withConfig({
  displayName: "MobileFooter__ImgAppStore",
  componentId: "lv466c-11"
})(["margin-right:12px;"]);
var DarkModeContainer = styled.div.withConfig({
  displayName: "MobileFooter__DarkModeContainer",
  componentId: "lv466c-12"
})(["display:flex;justify-content:center;align-items:center;width:100%;margin-bottom:36px;"]);
var TitleDarkMode = styled(Text).withConfig({
  displayName: "MobileFooter__TitleDarkMode",
  componentId: "lv466c-13"
})(["margin-right:16px;", ""], function (_ref5) {
  var styled = _ref5.styled;
  return styled && css(["color:", ";font-family:", ";line-height:", ";letter-spacing:", ";"], styled.colorTitle, styled.fontTitle, styled.lineHeightTitle, styled.letter);
});
var BadgeContainerLink = styled.a.withConfig({
  displayName: "MobileFooter__BadgeContainerLink",
  componentId: "lv466c-14"
})([""]);